import { render, staticRenderFns } from "./ConfirmShopsCommissionSPAdmin.vue?vue&type=template&id=ea591136&"
import script from "./ConfirmShopsCommissionSPAdmin.vue?vue&type=script&lang=js&"
export * from "./ConfirmShopsCommissionSPAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmShopsCommissionSPAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports